// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y0NY_GUec1G5TxtlIwyA {
  display: flex;
  flex-direction: column;
}

.HtlsMr2uiUtcgKHfIwfd {
  margin-bottom: 3rem;
}

.cX0YmP10va_1vF7zvaoA {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-gap: 4rem 2.5rem;
  gap: 4rem 2.5rem;
  justify-content: center;
}

.Y7SS_6TqLiYuOPjSYGBv {
  grid-column-start: span 2;
  justify-self: center;
}

@media only screen and
  (min-width: 1024px) and
  (max-width: 1279px) {
  .cX0YmP10va_1vF7zvaoA {
    grid-template-columns: repeat(2, min-content);
  }
}

@media only screen and
  (min-width: 640px) and
  (max-width: 1023px) {
  .cX0YmP10va_1vF7zvaoA {
    grid-template-columns: repeat(2, min-content);
    grid-gap: 2.5rem 1.25rem;
    gap: 2.5rem 1.25rem;
  }

  .HtlsMr2uiUtcgKHfIwfd {
    margin-bottom: 1rem;
  }
}

@media only screen and
  (max-width: 639px) {
  .cX0YmP10va_1vF7zvaoA {
    display: flex;
    flex-direction: column;
    grid-gap: unset;
    gap: unset;
  }

  .HtlsMr2uiUtcgKHfIwfd {
    margin-bottom: 1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SearchSuggestions/SearchSuggestions.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,qBAAc;EAAd,gBAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;;;EACE;IACE,6CAA6C;EAC/C;AACF;;AAEA;;;EACE;IACE,6CAA6C;IAC7C,wBAAc;IAAd,mBAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,eAAU;IAAV,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".searchSuggestions {\n  display: flex;\n  flex-direction: column;\n}\n\n.title {\n  margin-bottom: 48px;\n}\n\n.productsContainer {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 64px 40px;\n  justify-content: center;\n}\n\n.highlightedBlock {\n  grid-column-start: span 2;\n  justify-self: center;\n}\n\n@media (--desktop-small) {\n  .productsContainer {\n    grid-template-columns: repeat(2, min-content);\n  }\n}\n\n@media (--tablet) {\n  .productsContainer {\n    grid-template-columns: repeat(2, min-content);\n    gap: 40px 20px;\n  }\n\n  .title {\n    margin-bottom: 16px;\n  }\n}\n\n@media (--mobile) {\n  .productsContainer {\n    display: flex;\n    flex-direction: column;\n    gap: unset;\n  }\n\n  .title {\n    margin-bottom: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchSuggestions": `Y0NY_GUec1G5TxtlIwyA`,
	"title": `HtlsMr2uiUtcgKHfIwfd`,
	"productsContainer": `cX0YmP10va_1vF7zvaoA`,
	"highlightedBlock": `Y7SS_6TqLiYuOPjSYGBv`
};
export default ___CSS_LOADER_EXPORT___;
